import { getI18nMessage, I18nMessages } from "./i18n";

const testMessages: I18nMessages = {
    simple: "Simple Text",
    nested: {
        button: "Nested Button",
        another: {
            button: "Another Nested Button",
        },
    },
};

describe("i18n", () => {
    it("returns the correct message if the key exists", () => {
        expect(getI18nMessage("simple", testMessages)).toEqual("Simple Text");
    });

    it("resolves dot notated keys and returns the correct message if it exists", () => {
        expect(getI18nMessage("nested.button", testMessages)).toEqual(
            "Nested Button"
        );
        expect(getI18nMessage("nested.another.button", testMessages)).toEqual(
            "Another Nested Button"
        );
    });

    it("returns the key if it does not exist in the resource tree", () => {
        expect(getI18nMessage("unknown", testMessages)).toEqual("unknown");
        expect(getI18nMessage("unknown.nested.key", testMessages)).toEqual(
            "unknown.nested.key"
        );
    });

    it("returns the key if no valid resource is provided", () => {
        expect(getI18nMessage("missing.resource", undefined)).toEqual(
            "missing.resource"
        );
    });
});
